import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DepartmentsComponent } from './departments/departments.component';
import { DoctorHomeComponent } from './doctor-home/doctor-home.component';
import { DoctorprofileComponent } from './doctorprofile/doctorprofile.component';
import { DoctorregistrationComponent } from './doctorregistration/doctorregistration.component';
import { DprofileeditComponent } from './dprofileedit/dprofileedit.component';
import { PatientsSAdminComponent } from './patients-s-admin/patients-s-admin.component';
import { ApprovalsComponent } from './PendingApprovals/approvals.component';
import { RegisteredComponent } from './registered/registered.component';
import { TerminationComponent } from './termination/termination.component';
import { PrimengModule } from 'src/app/primeng/primeng.module';
import { DoctorRoutingModule } from './doctor-routing.module';
import { SharedModule } from '../../shared/shared.module';
// import { InitateAppointmentComponent } from './initate-appointment/initate-appointment.component';
import { SharePatientProfileComponent } from './share-patient-profile/share-patient-profile.component';
import { CovidFeedbacksComponent } from './covid-feedbacks/covid-feedbacks.component';
import { MedicalProfessionSharedModule } from '../shared/medical-profession-shared.module';
import { AdminModule } from './admin/admin.module';
import { LookupSearchPComponent } from './lookup-screen/lookup-patients/lookup-search-p/lookup-search-p.component';
import { LookupListPComponent } from './lookup-screen/lookup-patients/lookup-list-p/lookup-list-p.component';
import { LookupDisplayPComponent } from './lookup-screen/lookup-patients/lookup-display-p/lookup-display-p.component';
import { LookupSearchDComponent } from './lookup-screen/lookup-doctors/lookup-search-d/lookup-search-d.component';
import { LookupListDComponent } from './lookup-screen/lookup-doctors/lookup-list-d/lookup-list-d.component';
import { LookupDisplayDComponent } from './lookup-screen/lookup-doctors/lookup-display-d/lookup-display-d.component';
import { RefferalComponent } from './refferal/refferal.component';
import { AccountsModule } from './accounts/accounts.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AuthInterceptorService } from '../../../services/shared/auth-interceptor.service';
import { PatientViewModule } from '../../shared/patient-view/patient-view.module';
import { UtilitiesModule } from '../../shared/utilities/utilities.module';
import { AnalyticsDashboardComponent } from './analytics-dashboard/analytics-dashboard.component';
import { MarketingDashboardComponent } from './marketing-dashboard/marketing-dashboard.component';
import { ProviderLicencesComponent } from './provider-licences/provider-licences.component';
import { AdminApiKeysComponent } from './admin-api-keys/admin-api-keys.component';
import { ProviderUpdateComponent } from './provider-update/provider-update.component';
import { UpdateLogoComponent } from './update-logo/update-logo.component';
import { ApproveProviderComponent } from './approve-provider/approve-provider.component';
import { ProviderCountriesComponent } from './provider-countries/provider-countries.component';
import { LicenseTransactionsComponent } from './license-transactions/license-transactions.component';
import { ProviderTransactionsComponent } from './provider-transactions/provider-transactions.component';
import { PriorityListComponent } from './priority-list/priority-list.component';
import { ProviderAgreementComponent } from './provider-agreement/provider-agreement.component';
import { DoctorCertificatesComponent } from './doctor-certificates/doctor-certificates.component';
import { CertificatesComponent } from './certificates/certificates.component';
import { ApproveCertificateComponent } from './approve-certificate/approve-certificate.component';

@NgModule({
    declarations: [
        DepartmentsComponent,
        PatientsSAdminComponent,
        RegisteredComponent,
        ApprovalsComponent,
        DoctorregistrationComponent,
        TerminationComponent,
        DprofileeditComponent,
        DoctorHomeComponent,
        DoctorprofileComponent,
        //EsignComponent,
        // InitateAppointmentComponent,
        SharePatientProfileComponent,
        CovidFeedbacksComponent,
        LookupSearchPComponent,
        LookupListPComponent,
        LookupDisplayPComponent,
        LookupSearchDComponent,
        LookupListDComponent,
        LookupDisplayDComponent,
        RefferalComponent,
        AnalyticsDashboardComponent,
        MarketingDashboardComponent,
        ProviderLicencesComponent,
        AdminApiKeysComponent,
        ProviderUpdateComponent,
        UpdateLogoComponent,
        ApproveProviderComponent,
        ProviderCountriesComponent,
        LicenseTransactionsComponent,
        ProviderTransactionsComponent,
        PriorityListComponent,
        ProviderAgreementComponent,
        DoctorCertificatesComponent,
        CertificatesComponent,
        ApproveCertificateComponent
    ],
    imports: [
        CommonModule,
        PrimengModule,
        DoctorRoutingModule,
        SharedModule,
        MedicalProfessionSharedModule,
        AdminModule,
        AccountsModule,
        HttpClientModule,
        PatientViewModule,    
        UtilitiesModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptorService,
            multi: true
        }
    ]
})
export class DoctorsModule {}
